import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=8243b4c8"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"
import style0 from "./Demand.vue?vue&type=style&index=0&id=8243b4c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports